import React from "react";
import { SlideModal } from "./SlideModal";
import { ViewDetailsModalContent } from "./ViewDetailsModalContent";

export const ViewDetailsModal = ({
  setShowDetailsModal,
  onShareClick,
  onReviewClick,
  onEditClick,
  taxes,
  insurance,
  earnestMoney,
  credits,
  downPayment,
  insurancePaymentMonth,
  plannedClosingDate,
  hasWaivedEscrow,
  open,
  details,
  content,
}) => {
  return (
    <SlideModal open={open} direction="up" in mountOnEnter unmountOnExit>
      <ViewDetailsModalContent
        taxes={taxes}
        insurance={insurance}
        earnestMoney={earnestMoney}
        credits={credits}
        downPayment={downPayment}
        insurancePaymentMonth={insurancePaymentMonth}
        plannedClosingDate={plannedClosingDate}
        hasWaivedEscrow={hasWaivedEscrow}
        setShowDetailsModal={setShowDetailsModal}
        details={details}
        open={open}
        onShareClick={onShareClick}
        onReviewClick={onReviewClick}
        onEditClick={onEditClick}
        content={content}
      />
    </SlideModal>
  );
};
